// Register.js

import React, { Component } from 'react';
import Form from "react-jsonschema-form";
import JSONSchemaForm from "react-jsonschema-form";
import { connect } from 'react-redux';
import { updateAlert } from '../actions/alert-actions';


class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Form: JSONSchemaForm.default,
      jsonSchema: {
      "title": "Register Account",
      "description": "An account with a confirmed email address is required to book icetimes",
      "type": "object",
      "required": [
        "firstName",
        "lastName",
        "email",
        "password",
        "phone"
      ],
      "properties": {
        "firstName": {
          "type": "string",
          "title": "First name"
        },
        "lastName": {
          "type": "string",
          "title": "Last name"
        },
        "email": {
          "type": "string",
          "title": "Email Address"
        },
        "password": {
          "type": "string",
          "title": "Password",
          "minLength": 3
        },
        "phone": {
          "type": "string",
          "title": "Telephone Number",
          "minLength": 10
        }
      }
    },
    uiSchema: {
      "firstName": {
        "ui:autofocus": true,
        "ui:emptyValue": ""
      },
      "password": {
        "ui:widget": "password",
 //       "ui:help": "Hint: Make it strong!"
      },
      "telephone": {
        "ui:options": {
          "inputType": "tel"
        }
      }
    }
  }


    
  }

onUpdateAlert(message, type){
  console.log('Alert:', message, type);
  this.props.onUpdateAlert(message, type);
}

render() {
    return (
      <div>
        <div className="container">
            <div className="col-sm-6 offset-sm-3 mt-2">
                {this.props.alert &&
                    <div className={'alert alert-warning'}>{this.props.alert}</div>
                }
            </div>
        </div>
      <Form schema={this.state.jsonSchema}
        className="form form-wide"
        uiSchema={this.state.uiSchema}
        onSubmit={this.onSubmit.bind(this)} />
    </div>
    );
  }

onSubmit(formData) {
    console.log("Finally", formData.formData);
    var response = fetch('https://beisekerice.com/api/v0/register', {
//    var response = fetch('https://beiseker.bookice.ca/api/v0/register', {
//  var response = fetch('http://localhost:3001/api/v0/register', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData.formData)
    }).then(response => {
      if (!response.ok) {
          console.log(response.statusText);
          this.props.history.push(`/registration_success`);
          return Promise.reject(response.statusText);
      }
      console.log(response.statusText);
      return response.json();
  })
  .catch(error => {
    console.log(error);
    this.props.onUpdateAlert("Unable to Register Account.  Email address may already be registered.");
  });
  }
}


const mapStateToProps = state => ({
  products: state.products,
  user: state.user,
  alert: state.alert
});

const mapActionsToProps = {
  onUpdateAlert: updateAlert
};

export default connect(mapStateToProps, 
  mapActionsToProps
  )(Register);


// WEBPACK FOOTER //
// ./src/components/Register.js